"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timers = void 0;
exports.getCurrentTime = getCurrentTime;

var _constants = require("./constants");

var _id = require("./lib/id");

var _validation = require("./lib/validation");

var _getMs = require("./lib/get-ms");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_TIMER_CONFIG = {
  interval: _constants.Interval.SECONDS,
  unit: 1
};

function validateTimerConfig(timerConfig) {
  (0, _validation.validateInterval)(timerConfig.interval);

  if (typeof timerConfig.unit !== "undefined" && (!Number.isInteger(timerConfig.unit) || timerConfig.unit <= 0)) {
    throw new Error("unit must be a positive integer");
  }
}

function validateAddTimerArgs(callback, timerConfig) {
  if (!callback) {
    throw new Error("You need to provide a callback as the first argument to addTimer");
  }

  validateTimerConfig(timerConfig);
}

function getTimezoneOffset() {
  return new Date().getTimezoneOffset() * 60 * 1000;
}

function roundTick(ms, tick, interval) {
  var delta = tick % ms;

  if (interval === _constants.Interval.DAYS) {
    var timezoneDelta = delta - getTimezoneOffset();

    if (timezoneDelta > ms) {
      return tick + timezoneDelta;
    }

    delta = Math.abs(timezoneDelta);
  }

  return tick - delta;
}

function getCurrentTick(ms, interval) {
  return roundTick(ms, Date.now(), interval);
}

function getNextTick(interval, ms, time) {
  var newTime = time + ms;
  return roundTick(ms, newTime, interval);
}

function getUnixTimeStamp(tick) {
  return Math.floor(tick / 1000);
}

function getCurrentTime() {
  var timerConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateTimerConfig(timerConfig);

  var config = _objectSpread(_objectSpread({}, DEFAULT_TIMER_CONFIG), timerConfig);

  return getUnixTimeStamp(getCurrentTick((0, _getMs.getMs)(config.interval, config.unit), config.interval));
}

var Timers = /*#__PURE__*/function () {
  function Timers() {
    _classCallCheck(this, Timers);

    _defineProperty(this, "timers", {});

    _defineProperty(this, "currentTimeout", void 0);

    _defineProperty(this, "nextTick", 0);

    this.addTimer = this.addTimer.bind(this);
    this.removeAllTimers = this.removeAllTimers.bind(this);
    this.removeTimer = this.removeTimer.bind(this);
    this.revalidateAllTimers = this.revalidateAllTimers.bind(this);
  }

  _createClass(Timers, [{
    key: "removeAllTimers",
    value: function removeAllTimers() {
      this.timers = {};
      this.revalidateAllTimers();
    }
  }, {
    key: "addTimer",
    value: function addTimer(callback) {
      var _this = this;

      var timerConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      validateAddTimerArgs(callback, timerConfig);
      var id = (0, _id.generateId)();

      var newTimerBase = _objectSpread(_objectSpread({}, DEFAULT_TIMER_CONFIG), timerConfig);

      var ms = (0, _getMs.getMs)(newTimerBase.interval, newTimerBase.unit);

      var newTimer = _objectSpread(_objectSpread({}, newTimerBase), {}, {
        callback: callback,
        id: id,
        ms: ms,
        nextTick: getNextTick(newTimerBase.interval, ms, Date.now())
      });

      this.timers[id] = newTimer;

      if (!this.nextTick || newTimer.nextTick < this.nextTick) {
        this.revalidateAllTimers();
      }

      return function () {
        return _this.removeTimer(id);
      };
    }
  }, {
    key: "revalidateAllTimers",
    value: function revalidateAllTimers() {
      var _this2 = this;

      clearTimeout(this.currentTimeout);
      var now = Date.now();
      this.nextTick = Object.keys(this.timers).reduce(function (prev, timerId) {
        var timer = _this2.timers[timerId];

        if (!timer) {
          // Timer was already removed within callback of another timer
          return prev;
        }

        if (timer.nextTick <= now) {
          var usedTime = roundTick(timer.ms, now, timer.interval);
          timer.callback(getUnixTimeStamp(usedTime));
          timer.nextTick = getNextTick(timer.interval, timer.ms, now);
        }

        if (!prev || prev > timer.nextTick) {
          return timer.nextTick;
        }

        return prev;
      }, 0);

      if (this.nextTick) {
        var nextTickDelta = this.nextTick - Date.now();
        this.currentTimeout = setTimeout(this.revalidateAllTimers, nextTickDelta);
      }
    }
  }, {
    key: "removeTimer",
    value: function removeTimer(id) {
      var timer = this.timers[id];

      if (!timer) {
        return;
      }

      delete this.timers[id];

      if (timer.nextTick === this.nextTick) {
        this.revalidateAllTimers();
      }
    }
  }]);

  return Timers;
}();

exports.Timers = Timers;